import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Advt from './components/Advt/Advt';
import Message from './components/Message/Message';
import { useBroadcast } from './hooks/useBroadcast';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

import { useMemo } from 'react';
import { QRcode } from './components/QRcode/QRcode';

function App() {
  const { currentState, isVisible, currentMessage, messageAnimationTrigger } =
    useBroadcast();

  const {
    bg,
    phoneNumber,
    socials,
    title,
    qrCode,
    sizeQR,
    paddingQR,
    colorFontAdvt,
    colorFontMessage,
  } = useGetParams();

  const advtInfo = useMemo(
    () => ({
      qrCode: qrCode,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title, qrCode]
  );

  return (
    <div
      className="app-wrapper"
      style={{
        background: `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat`,
      }}>
      <CSSTransition
        in={isVisible}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit>
        <div className="titre-wrapper">
          <QRcode sizeQR={sizeQR} qrCode={qrCode} paddingQR={paddingQR} />

          <div
            className="advtMessageWrapper"
            style={{ height: `${sizeQR}rem` }}>
            <Advt advtInfo={advtInfo} colorFontAdvt={colorFontAdvt} />
            <div className="message-wrapper">
              <CSSTransition
                in={currentMessage && currentState === 'S1'}
                timeout={500}
                classNames="fade-scale"
                unmountOnExit>
                <SwitchTransition>
                  <CSSTransition
                    key={messageAnimationTrigger}
                    addEndListener={(node, done) => {
                      node.addEventListener('transitionend', done, false);
                    }}
                    classNames="fade">
                    <Message
                      message={currentMessage?.message || {}}
                      colorFontMessage={colorFontMessage}
                    />
                  </CSSTransition>
                </SwitchTransition>
              </CSSTransition>
            </div>
          </div>
        </div>
      </CSSTransition>
      <div id="img-loader"></div>
    </div>
  );
}

export default App;
